import { useState } from "react";

// components
import { Button } from "shared/components/bulma/button";
import { ClipboardCopy } from "shared/pipes/clipboard-copy";

// helpers
import * as helper from './helper';

const GeneratePassword = ({ customer }) => {

    const [loading, setLoading] = useState(false);
    const [generatedPassword, setGeneratedPassword] = useState(null);

    const handleClick = async () => {
        if (!window.confirm('Are you sure you want to generate a password?')) {
            return;
        }

        setLoading(true);
        setGeneratedPassword(null);

        try {
            setGeneratedPassword(await helper.setPassword(customer));
        } catch (error) {
            setGeneratedPassword(error);
        }

        setLoading(false);
    }

    const DisplayPassword = () => {
        if (!generatedPassword) {
            return null;
        }

        return (
            <ClipboardCopy value={generatedPassword}>
                <small>
                    <span className="icon-text">
                        <span className="icon">
                            <i className="fas fa-mouse"></i>
                        </span>
                        <span>Click me to copy the new password</span>
                    </span>
                </small>
            </ClipboardCopy>
        );
    }

    return (
        <>
            <Button className={`${loading ? 'is-loading' : ''}`} onClick={handleClick} disabled={loading}>
                Generate Password
            </Button>
            <div className="mt-4">
                <DisplayPassword />
            </div>

            {loading && <progress className="mt-4 progress is-small is-primary" max="100">15%</progress>}

            <pre className="mt-4">{generatedPassword ? generatedPassword : '{}'}</pre>
        </>
    );
};

export { GeneratePassword };
